import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { BackOrderOptions, TypeIds } from "../constants/constants";
import { UtilityService } from "../utils/utility.service";

@Injectable({
    providedIn: "root",
})
export class SoStageChangeService {

    constructor(private utilityService: UtilityService) { }

    isVisibleBackOrderSelectionDialog(soDetails: any, isEnabledBackOrder = false, isEnabledBackOrderKit = false, isEnabledBackOrderBundle = false): boolean {
        let isProductsQrdQtyGreaterThan = false;
        let isBundleProductsQrdQtyGreaterThan = false;
        let isKitProductsQrdQtyGreaterThan = false;
        if (isEnabledBackOrder) {
            soDetails?.salesOrderProducts?.forEach((p) => {
                /**
                 * Bundle & kit items
                 * calculating difference between ordered qty and pick/pack qty, based on configuration
                 */
                if (p?.salesOrderBundleDetail && p?.salesOrderBundleDetail?.length) {
                    p?.salesOrderBundleDetail?.forEach((bp) => {
                        if (p.product?.typeId == TypeIds.BundleTypeId && isEnabledBackOrderBundle) {
                            if (!isBundleProductsQrdQtyGreaterThan) {
                                const qty = bp.packedQty;
                                isBundleProductsQrdQtyGreaterThan = Number(bp.quantity) > Number(qty);
                            }
                        }
                        else if (p.product?.typeId == TypeIds.KitTypeId && isEnabledBackOrderKit) {
                            if (!isKitProductsQrdQtyGreaterThan) {
                                const qty = p.packedQty;
                                isKitProductsQrdQtyGreaterThan = Number(p.quantity) > Number(qty); // for kit, need to check parent item's ord qty and available qty
                            }
                        }
                    });
                }

                /**
                 * Inventory items
                 * calculating difference between ordered qty and pick/pack qty, based on configuration
                 */
                if (p && p.product?.typeId == TypeIds.InventoryTypeId) {
                    if (!isProductsQrdQtyGreaterThan) {
                        const qty = p.packedQty;
                        isProductsQrdQtyGreaterThan = Number(p.quantity) > Number(qty);
                    }
                }
            });
            const displayBackOrderOptions = isEnabledBackOrder && soDetails.backOrderTypeId == 0 && (isProductsQrdQtyGreaterThan || isBundleProductsQrdQtyGreaterThan || isKitProductsQrdQtyGreaterThan);
            return displayBackOrderOptions;
        }
        return false;
    }

    prepareEnteredToPickStageChangeData(soObj, app, isAutoPick, sodetailsDeepCopy) {
        let salesOrderObj = _.cloneDeep(soObj);
        salesOrderObj.salesOrderDate = sodetailsDeepCopy.salesOrderDate;
        for (let soProduct of salesOrderObj?.salesOrderProducts) {
            for (let bProduct of soProduct?.salesOrderBundleDetail) {
                if (bProduct?.childSalesOrderBundleDetail?.length > 0) {
                    for (let kp of bProduct?.childSalesOrderBundleDetail) {
                        kp.pickedQty = isAutoPick ? kp.quantity : 0;
                        kp.packedQty = 0;
                    }
                }
                bProduct.pickedQty = isAutoPick ? bProduct.quantity : 0;
                bProduct.packedQty = 0;
            };
            soProduct.pickedQty = isAutoPick ? soProduct.quantity : 0;
            soProduct.packedQty = 0;
        }
        this.setNullValues(salesOrderObj);
        return salesOrderObj;
    }
    prepareEnteredToPackStageChangeData(soObj, app, isAutoPick, isAutoPack, sodetailsDeepCopy) {
        let salesOrderObj = _.cloneDeep(soObj);
        salesOrderObj.salesOrderDate = sodetailsDeepCopy.salesOrderDate;
        for (let soProduct of salesOrderObj?.salesOrderProducts) {
            for (let bProduct of soProduct?.salesOrderBundleDetail) {
                if (bProduct?.childSalesOrderBundleDetail?.length > 0) {
                    for (let kp of bProduct?.childSalesOrderBundleDetail) {
                        kp.pickedQty = isAutoPick ? kp.quantity : 0;
                        kp.packedQty = isAutoPack ? kp.pickedQty : 0;
                    };
                }
                bProduct.pickedQty = isAutoPick ? bProduct.quantity : 0;
                bProduct.packedQty = isAutoPack ? bProduct.pickedQty : 0;
            };
            soProduct.pickedQty = isAutoPick ? soProduct.quantity : 0;
            soProduct.packedQty = isAutoPack ? soProduct.pickedQty : 0;
        }
        this.setNullValues(salesOrderObj);
        return salesOrderObj;
    }
    preparePickToPackStageChangeData(soObj, app, isAutoPack, sodetailsDeepCopy) {
        let salesOrderObj = _.cloneDeep(soObj);
        salesOrderObj.salesOrderDate = sodetailsDeepCopy.salesOrderDate;
        for (let soProduct of salesOrderObj?.salesOrderProducts) {
            for (let bProduct of soProduct?.salesOrderBundleDetail) {
                if (bProduct?.childSalesOrderBundleDetail?.length > 0) {
                    for (let kp of bProduct?.childSalesOrderBundleDetail) {
                        kp.pickedQty = kp.pickedQty;
                        kp.packedQty = isAutoPack ? kp.pickedQty : 0;
                    };
                }
                bProduct.pickedQty = bProduct.pickedQty;
                bProduct.packedQty = isAutoPack ? bProduct.pickedQty : 0;
            };
            soProduct.pickedQty = soProduct.pickedQty;
            soProduct.packedQty = isAutoPack ? soProduct.pickedQty : 0;
        }
        this.setNullValues(salesOrderObj);
        return salesOrderObj;
    }
    prepareLabellingOrVerificationStageChangeData(soObj, app, sodetailsDeepCopy) {
        let salesOrderObj = _.cloneDeep(soObj);
        salesOrderObj.salesOrderDate = sodetailsDeepCopy.salesOrderDate;
        for (let soProduct of salesOrderObj?.salesOrderProducts) {
            for (let bProduct of soProduct?.salesOrderBundleDetail) {
                if (bProduct?.childSalesOrderBundleDetail?.length > 0) {
                    for (let kp of bProduct?.childSalesOrderBundleDetail) {
                        kp.pickedQty = kp.pickedQty;
                        kp.packedQty = kp.packedQty;
                    }
                }
                bProduct.pickedQty = bProduct.pickedQty;
                bProduct.packedQty = bProduct.packedQty;
            };
            soProduct.pickedQty = soProduct.pickedQty;
            soProduct.packedQty = soProduct.packedQty;
        }
        this.setNullValues(salesOrderObj);
        return salesOrderObj;
    }

    // check product's row wise Discount visible or not
    checkRowWiseDiscountVisibilty(soDetailsTemplates) {
        return soDetailsTemplates["labels_table"] && soDetailsTemplates["labels_table"].length >= 6 ? soDetailsTemplates["labels_table"][6]?.isChecked : false;
    }

    // check product's row wise Tax visible or not
    checkRowWiseTaxVisibilty(soDetailsTemplates) {
        return soDetailsTemplates["labels_table"] && soDetailsTemplates["labels_table"].length >= 5 ? soDetailsTemplates["labels_table"][5]?.isChecked : false;
    }

    calculateDiscountByDiscountType(soObj: any): number {
        let discount = 0;
        if (soObj?.discountAmount) {
            if (soObj?.discountType?.name == "$" || soObj?.discountType?.name == "Amount") {
                discount = soObj?.discountAmount;
            } else if (soObj?.discountType?.name == "%" || soObj?.discountType?.name == "Percentage") {
                let num = soObj?.discountAmount ? ((Number(soObj.discountAmount) * 100) / Number(soObj.totalAmount)) : 0;
                discount = num ? (Math.round(num * 100) / 100) : 0;
            }
        }
        return discount;
    }

    calculateOrderTotalDiscountAmount(soObj, discount, productTotal, isVisibleDiscount): number {
        let discountValue = 0;
        if (soObj?.discountAmount && discount) {
            if (!isVisibleDiscount) {
                if (soObj?.discountType?.name == "%" || soObj?.discountType?.name == "Percentage") {
                    discountValue = Number(productTotal * (Number(discount) / 100));
                } else if (soObj?.discountType?.name == "$" || soObj?.discountType?.name == "Amount") {
                    discountValue = Number(discount);
                }
            } else {
                soObj?.salesOrderProducts.forEach((e) => {
                    if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length && (e.typeId == TypeIds.BundleTypeId || e.typeId == TypeIds.KitTypeId)) {
                        e?.salesOrderBundleDetail?.forEach((b) => {
                            discountValue += Number(b?.discountAmount);
                        });
                    } else {
                        discountValue += Number(e?.discountAmount);
                    }
                });
            }
        }
        return discountValue;
    }

    calculateOrderTotalTaxAmount(soObj, isVisibleTax, productTotal, taxEnabled): number {
        // const taxRate = soObj?.tax && soObj?.tax?.taxRate ? soObj.tax.taxRate : 0;
        let taxAmount = 0;
        if (taxEnabled) {
            if (!isVisibleTax) {
                // taxAmount = Number(productTotal) * (taxRate / 100);
                let subTaxes = soObj?.tax?.subTax || [];
                for (let sTax of subTaxes) {
                    taxAmount += this.utilityService.calculateProductsTax(sTax.taxRate, productTotal);
                }
            } else {
                soObj?.salesOrderProducts.forEach((e) => {
                    if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length && (e?.typeId == TypeIds.BundleTypeId || e?.typeId == TypeIds.KitTypeId)) {
                        e?.salesOrderBundleDetail?.forEach((b) => {
                            taxAmount += Number(b?.taxAmount);
                        });
                    } else {
                        taxAmount += Number(e?.taxAmount);
                    }
                });
            }
        }
        return taxAmount;
    }

    // calculating picked qty based on product type(inventory, non-inventory & service)
    getPickQtyByProductType(isEnabledBackOrder, isEnabledBackOrderKit, selectedBackOrderOption, totalAvailQty, item): number {
        let pickQty = 0;
        if (item.product?.typeId == TypeIds.ServiceTypeId || item.product?.typeId == TypeIds.NonInventoryTypeId) {
            pickQty = item.quantity;
        } else if (item.product?.typeId == TypeIds.InventoryTypeId) {
            pickQty = !isEnabledBackOrder ? item.quantity
                : selectedBackOrderOption == BackOrderOptions.SHIP
                    ? item.quantity
                    : selectedBackOrderOption == BackOrderOptions.BACK_ORDER && totalAvailQty <= 0
                        ? 0
                        : this.utilityService.getPickedQty(totalAvailQty, item.quantity);
        } else if (item.product?.typeId == TypeIds.KitTypeId || item.product?.typeId == TypeIds.BundleTypeId) {
            pickQty = !isEnabledBackOrderKit ? item.quantity
                : selectedBackOrderOption == BackOrderOptions.SHIP
                    ? item.quantity
                    : selectedBackOrderOption == BackOrderOptions.BACK_ORDER && totalAvailQty <= 0
                        ? 0
                        : this.utilityService.getPickedQty(totalAvailQty, item.quantity);
        }
        return pickQty;
    }

    // calculating bundle products picked qty
    getBundleProductsPickQty(isEnabledBackOrderBundle, selectedBackOrderOption, btotalAvailQty, item, pickQty, uomValue): number {
        let bPickQty = 0;
        bPickQty = !isEnabledBackOrderBundle ? item.quantity
            : selectedBackOrderOption == BackOrderOptions.SHIP
                ? item.quantity
                : selectedBackOrderOption == BackOrderOptions.BACK_ORDER && btotalAvailQty <= 0
                    ? 0
                    : this.utilityService.getPickedQty(btotalAvailQty, item.quantity);
        return bPickQty;
    }

    // calculating kit products picked qty 
    getKitProductsPickQty(isEnabledBackOrderKit, selectedBackOrderOption, item, soProduct, totalAvailQty, pickQty): number {
        let bPickQty = 0;
        bPickQty = !isEnabledBackOrderKit ? item.quantity
            : selectedBackOrderOption == BackOrderOptions.SHIP
                ? item.quantity
                : this.utilityService.getKitProductsPickQty(item.originalQty, pickQty, totalAvailQty);
        return bPickQty;
    }

    calculateDiscountAmountByQty(product, qty) {
        const uomValue = product && product.unit && product.unit.uomDetail && product.unit.uomDetail.value
            ? product.unit.uomDetail.value
            : 1;
        if (qty > 0) {
            return product?.discountType?.description == "%" && product.discountAmount
                ? (Number(product.discountAmount) * 100) / (Number(qty) * Number(uomValue) * Number(product.pricePerProduct))
                : product.discountAmount;
        } else {
            return product?.discountType?.description == "%" && product.discountAmount
                ? (Number(product.discountAmount) * 100) / (Number(product.quantity) * Number(uomValue) * Number(product.pricePerProduct))
                : product.discountAmount;
        }
    }

    calculateTaxAmountByQty(product, qty, isVisibleTax, bundle?) {
        let amount = 0;
        const uomValue = product?.unit?.uomDetail?.value || 1;
        let productsTotalTax = 0;
        if (isVisibleTax) {
            if (bundle && bundle.product.typeId == TypeIds.BundleTypeId) {
                product?.salesOrderBundleDetailSubTax?.forEach((sTax) => {
                    productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, (Number(qty) * Number(uomValue) * Number(product.pricePerProduct)));
                });
            } else {
                product?.salesOrderProductSubTax?.forEach((sTax) => {
                    productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, (Number(qty) * Number(uomValue) * Number(product.pricePerProduct)));
                });
            }
        }
        return productsTotalTax;
    }

    setNullValues(soObj) {
        soObj.salesOrderNote = null;
        soObj.salesOrderAudit = null;
        soObj.account = null;
        soObj.warehouse = null;
        soObj.user = null;
        soObj.shippingAddress = null;
        soObj.discountType = null;
        soObj.paymentMethod = null;
        soObj.paymentTerm = null;
        soObj.shippingMethod = null;
        soObj.shippingTerm = null;
        soObj.contact = null;
        soObj.shipContact = null;
        if (soObj.salesOrderProducts && soObj.salesOrderProducts.length) {
            soObj.salesOrderProducts.forEach(e => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length) {
                    e?.salesOrderBundleDetail?.forEach(b => {
                        b.product = null;
                        b?.childSalesOrderBundleDetail?.forEach(k => {
                            k.product = null;
                        })
                    })
                }
            });
        }
    }
}



